// Auto-generated from shared Rust constants. Do not edit.
// generator: shared-constants-v2

export const Validation = {
  MAX_NAME_LEN: 200,
  MAX_RECEIPT_NAME_LEN: 64,
  MAX_NOTE_LEN: 500,
  MAX_SHORT_TEXT_LEN: 100,
  MAX_EMAIL_LEN: 254,
  MIN_PASSWORD_LEN: 4,
  MAX_PASSWORD_LEN: 128,
  MAX_URL_LEN: 2048,
  MAX_ADDRESS_LEN: 500,
} as const;

export const AnomalyReview = {
  BULK_REVIEW_MAX_IDS: 100,
} as const;

export const Notification = {
  I18N_PARAM_PREFIX: '$t:',
} as const;

export const ImagePolicy = {
  MAX_FILE_SIZE: 20971520,
  MAX_IMAGES_PER_TENANT: 5000,
  MAGIC_MIN_LEN: 12,
  SUPPORTED_FORMATS: ['png', 'jpg', 'jpeg', 'webp'] as const,
} as const;

export const EdgeDefaults = {
  DEFAULT_HTTP_PORT: 9625,
  DEFAULT_MESSAGE_PORT: 9626,
} as const;

export const Protocol = {
  PROTOCOL_ERROR_CODE: 9306,
  MESSAGE_BUS_PROTOCOL_VERSION: 3,
  KDS_WS_PROTOCOL: 'crab.kds.v1',
  CONSOLE_WS_PROTOCOL: 'crab.console.v1',
  MAX_MESSAGE_PAYLOAD_SIZE: 16777216,
  CLOUD_EDGE_WS_PING_INTERVAL_SECS: 30,
  CLOUD_EDGE_WS_HEARTBEAT_TIMEOUT_SECS: 90,
  CLOUD_EDGE_WS_MAX_FRAME_BYTES: 67108864,
} as const;

export const Calendar = {
  WEEK_DAYS_SUNDAY_FIRST: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const,
  WEEK_DAYS_MONDAY_FIRST: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const,
  WEEK_ORDER_MONDAY_FIRST: [1, 2, 3, 4, 5, 6, 0] as const,
  BUSINESS_DAY_CUTOFF_PRESETS_MINUTES: [0, 60, 120, 180, 240, 300, 360, 420, 480] as const,
} as const;

export const CountryProfileOptions = {
  BUSINESS_TYPES: ['RESTAURANT', 'CAFE', 'BAR', 'FAST_FOOD', 'BAKERY', 'PIZZERIA', 'ICE_CREAM', 'FOOD_TRUCK'] as const,
  CUISINE_TYPES: ['SPANISH', 'ITALIAN', 'CHINESE', 'JAPANESE', 'THAI', 'INDIAN', 'MEDITERRANEAN', 'AMERICAN', 'MEXICAN', 'FRENCH', 'KOREAN', 'VIETNAMESE', 'INTERNATIONAL'] as const,
  PRICE_TIERS: ['BUDGET', 'STANDARD', 'PREMIUM', 'LUXURY'] as const,
} as const;

export const OrderEnums = {
  VOID_TYPES: ['CANCELLED', 'LOSS_SETTLED', 'PLATFORM_CANCELLED', 'STORE_REJECTED'] as const,
  MANUAL_VOID_TYPES: ['CANCELLED', 'LOSS_SETTLED'] as const,
  CANCEL_REASONS: ['CUSTOMER_CANCELLED', 'DUPLICATE_ORDER', 'SYSTEM_TEST', 'WRONG_TABLE', 'OUT_OF_STOCK', 'SYSTEM_AUTO'] as const,
  MANUAL_CANCEL_REASONS: ['CUSTOMER_CANCELLED', 'DUPLICATE_ORDER', 'SYSTEM_TEST', 'WRONG_TABLE', 'OUT_OF_STOCK'] as const,
  LOSS_REASONS: ['CUSTOMER_FLED', 'REFUSED_TO_PAY', 'SPILLAGE_BREAKAGE', 'STAFF_MEAL', 'MANAGER_COMP'] as const,
  REFUND_REASONS: ['CUSTOMER_REQUEST', 'WRONG_ORDER', 'QUALITY_ISSUE', 'OVERCHARGE', 'WAIT_TOO_LONG', 'ALLERGY_CONCERN'] as const,
} as const;

export const ComplianceEnums = {
  VOID_REASONS: ['TEST_ORDER', 'WRONG_CUSTOMER', 'DUPLICATE'] as const,
} as const;

export const SpainVerifactu = {
  CUSTOMER_LEGAL_NAME_MAX_CHARS: 120,
  IDOTRO_ID_MAX_CHARS: 20,
  AEAT_COUNTRY_TYPE2_CODES: ['AF', 'AL', 'DE', 'AD', 'AO', 'AI', 'AQ', 'AG', 'SA', 'DZ', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BE', 'BZ', 'BJ', 'BM', 'BY', 'BO', 'BA', 'BW', 'BV', 'BR', 'BN', 'BG', 'BF', 'BI', 'BT', 'CV', 'KY', 'KH', 'CM', 'CA', 'CF', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'KP', 'KR', 'CI', 'CR', 'HR', 'CU', 'TD', 'CZ', 'CL', 'CN', 'CY', 'CW', 'DK', 'DM', 'DO', 'EC', 'EG', 'AE', 'ER', 'SK', 'SI', 'ES', 'US', 'EE', 'ET', 'FO', 'PH', 'FI', 'FJ', 'FR', 'GA', 'GM', 'GE', 'GS', 'GH', 'GI', 'GD', 'GR', 'GL', 'GU', 'GT', 'GG', 'GN', 'GQ', 'GW', 'GY', 'HT', 'HM', 'HN', 'HK', 'HU', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IS', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KG', 'KI', 'KW', 'LA', 'LS', 'LV', 'LB', 'LR', 'LY', 'LI', 'LT', 'LU', 'XG', 'MO', 'MK', 'MG', 'MY', 'MW', 'MV', 'ML', 'MT', 'FK', 'MP', 'MA', 'MH', 'MU', 'MR', 'YT', 'UM', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MZ', 'MM', 'NA', 'NR', 'CX', 'NP', 'NI', 'NE', 'NG', 'NU', 'NF', 'NO', 'NC', 'NZ', 'IO', 'OM', 'NL', 'BQ', 'PK', 'PW', 'PA', 'PG', 'PY', 'PE', 'PN', 'PF', 'PL', 'PT', 'PR', 'QA', 'GB', 'RW', 'RO', 'RU', 'RE', 'SB', 'SV', 'WS', 'AS', 'KN', 'SM', 'SX', 'PM', 'VC', 'SH', 'LC', 'ST', 'SN', 'RS', 'SC', 'SL', 'SG', 'SY', 'SO', 'LK', 'SZ', 'ZA', 'SD', 'SS', 'SE', 'CH', 'SR', 'TH', 'TW', 'TZ', 'TJ', 'PS', 'TF', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TC', 'TM', 'TR', 'TV', 'UA', 'UG', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VN', 'VG', 'VI', 'WF', 'YE', 'DJ', 'ZM', 'ZW', 'QU', 'XB', 'XU', 'XN'] as const,
} as const;

export const Permission = {
  AUDIT_VIEW: 'audit:view',
  CASH_DRAWER_OPEN: 'cash_drawer:open',
  COMPLIANCE_MANAGE: 'compliance:manage',
  COSTING_MANAGE: 'costing:manage',
  CUSTOMERS_VIEW: 'customers:view',
  DEVICES_MANAGE: 'devices:manage',
  EMPLOYEES_MANAGE: 'employees:manage',
  INVENTORY_MANAGE: 'inventory:manage',
  KDS_EXPEDITE: 'kds:expedite',
  KDS_PRODUCE: 'kds:produce',
  KDS_SUPERVISE: 'kds:supervise',
  MARKETING_MANAGE: 'marketing:manage',
  MENU_MANAGE: 'menu:manage',
  ORDERS_AD_HOC_ITEM: 'orders:ad_hoc_item',
  ORDERS_CANCEL_ITEM: 'orders:cancel_item',
  ORDERS_COLLECT_RECEIVABLE: 'orders:collect_receivable',
  ORDERS_COMP: 'orders:comp',
  ORDERS_DEEP_DISCOUNT: 'orders:deep_discount',
  ORDERS_DEFER_PAYMENT: 'orders:defer_payment',
  ORDERS_DISCOUNT: 'orders:discount',
  ORDERS_EDIT_TAKEOVER: 'orders:edit_takeover',
  ORDERS_LINK_MEMBER: 'orders:link_member',
  ORDERS_MODIFY_PRICE: 'orders:modify_price',
  ORDERS_REDEEM_STAMP: 'orders:redeem_stamp',
  ORDERS_REFUND: 'orders:refund',
  ORDERS_REPRINT: 'orders:reprint',
  ORDERS_VIEW_ACTIVE: 'orders:view_active',
  ORDERS_VIEW_HISTORY: 'orders:view_history',
  ORDERS_VOID: 'orders:void',
  ORDERS_WRITE: 'orders:write',
  ORDERS_WRITE_OFF_RECEIVABLE: 'orders:write_off_receivable',
  PRICE_RULES_MANAGE: 'price_rules:manage',
  RECEIVABLES_VIEW: 'receivables:view',
  REPORTS_VIEW: 'reports:view',
  RESERVATIONS_DECIDE: 'reservations:decide',
  RESERVATIONS_VIEW: 'reservations:view',
  SETTINGS_MANAGE: 'settings:manage',
  SHIFTS_FORCE_CLOSE: 'shifts:force_close',
  SHIFTS_MANAGE: 'shifts:manage',
  TABLES_MANAGE: 'tables:manage',
  TABLES_MERGE_BILL: 'tables:merge_bill',
  TABLES_TRANSFER: 'tables:transfer',
  USERS_MANAGE: 'users:manage',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];
export const ALL_PERMISSIONS = ['menu:manage', 'costing:manage', 'tables:manage', 'shifts:manage', 'shifts:force_close', 'reports:view', 'audit:view', 'price_rules:manage', 'settings:manage', 'devices:manage', 'inventory:manage', 'marketing:manage', 'orders:write', 'orders:view_active', 'orders:view_history', 'orders:edit_takeover', 'orders:link_member', 'orders:redeem_stamp', 'orders:void', 'orders:discount', 'orders:deep_discount', 'orders:comp', 'orders:refund', 'orders:modify_price', 'orders:ad_hoc_item', 'orders:cancel_item', 'orders:reprint', 'orders:defer_payment', 'orders:collect_receivable', 'orders:write_off_receivable', 'customers:view', 'receivables:view', 'reservations:view', 'reservations:decide', 'tables:transfer', 'tables:merge_bill', 'cash_drawer:open', 'kds:produce', 'kds:expedite', 'kds:supervise', 'compliance:manage', 'employees:manage'] as const;
export const ADMIN_ONLY_PERMISSIONS = ['users:manage', 'all'] as const;

export const ORDER_COMMAND_PERMISSIONS = ['orders:void', 'orders:refund', 'orders:discount', 'orders:deep_discount', 'orders:comp', 'orders:modify_price', 'orders:cancel_item', 'orders:ad_hoc_item', 'orders:link_member', 'orders:redeem_stamp', 'orders:defer_payment', 'tables:transfer', 'tables:merge_bill'] as const;

export const DEFAULT_ADMIN_PERMISSIONS = ['all'] as const;

export const MAX_NAME_LEN = Validation.MAX_NAME_LEN;
export const MAX_RECEIPT_NAME_LEN = Validation.MAX_RECEIPT_NAME_LEN;
export const MAX_NOTE_LEN = Validation.MAX_NOTE_LEN;
export const MAX_SHORT_TEXT_LEN = Validation.MAX_SHORT_TEXT_LEN;
export const MAX_EMAIL_LEN = Validation.MAX_EMAIL_LEN;
export const MIN_PASSWORD_LEN = Validation.MIN_PASSWORD_LEN;
export const MAX_PASSWORD_LEN = Validation.MAX_PASSWORD_LEN;
export const MAX_URL_LEN = Validation.MAX_URL_LEN;
export const MAX_ADDRESS_LEN = Validation.MAX_ADDRESS_LEN;
export const MAX_FILE_SIZE = ImagePolicy.MAX_FILE_SIZE;
export const SUPPORTED_IMAGE_FORMATS = ImagePolicy.SUPPORTED_FORMATS;
export const DEFAULT_HTTP_PORT = EdgeDefaults.DEFAULT_HTTP_PORT;
export const DEFAULT_MESSAGE_PORT = EdgeDefaults.DEFAULT_MESSAGE_PORT;
export const PROTOCOL_ERROR_CODE = Protocol.PROTOCOL_ERROR_CODE;
export const MESSAGE_BUS_PROTOCOL_VERSION = Protocol.MESSAGE_BUS_PROTOCOL_VERSION;
export const ORDER_VOID_TYPES = OrderEnums.VOID_TYPES;
export const ORDER_MANUAL_VOID_TYPES = OrderEnums.MANUAL_VOID_TYPES;
export const ORDER_CANCEL_REASONS = OrderEnums.CANCEL_REASONS;
export const ORDER_MANUAL_CANCEL_REASONS = OrderEnums.MANUAL_CANCEL_REASONS;
export const ORDER_LOSS_REASONS = OrderEnums.LOSS_REASONS;
export const ORDER_REFUND_REASONS = OrderEnums.REFUND_REASONS;
export const ORDER_DEFAULT_VOID_TYPE = OrderEnums.MANUAL_VOID_TYPES[0];
export const ORDER_DEFAULT_LOSS_VOID_TYPE = OrderEnums.MANUAL_VOID_TYPES[1];
export const ORDER_DEFAULT_CANCEL_REASON = OrderEnums.MANUAL_CANCEL_REASONS[0];
export const COMPLIANCE_VOID_REASONS = ComplianceEnums.VOID_REASONS;
export const COMPLIANCE_DEFAULT_VOID_REASON = ComplianceEnums.VOID_REASONS[0];
